import { FeedbackIndexTable } from './feedback-table/feedback-index.table';
import { GoalIndexTable } from './goal-table/goal-index.table';
import { ReviewIndexTable } from './review-table/review-index.table';
import { SurveyIndexTable } from './survey-table/survey-index.table';

const Tables = [FeedbackIndexTable, GoalIndexTable, ReviewIndexTable, SurveyIndexTable];

export { FeedbackIndexTable, GoalIndexTable, ReviewIndexTable, SurveyIndexTable, Tables };
